<div class="main-wrapper">
    <div *ngIf="isLoading" class="full-page-loader">
        <app-progress-spinner [color]="'primary'" [diameter]="50" [strokeWidth]="5" [mode]="'indeterminate'">
        </app-progress-spinner>
    </div>
    <div class="login-container">
        <div class="logo-container">
            <a routerLink="/">
                <img src="../../../assets/img/safetly_image.webp" loading="lazy" alt="Safetly Logo">
            </a>
        </div>
        <div class="login-content">
            <div class="social-login">
                <h3>{{'buttons.login' | translate}}</h3>
                <div class="social-login-buttons">
                    <button (click)="signInWithGoogle()" aria-label="Sign In with Google">
                        <ng-container *ngIf="lastUsedAccount; else defaultGoogleBtn">
                            <img [src]="lastUsedAccount.picture" loading="lazy" alt="Google Avatar" class="google-avatar">
                            <span class="google-email">{{ lastUsedAccount.email }}</span>
                        </ng-container>
                        <ng-template #defaultGoogleBtn>
                            <img src="../../../assets/svg/google-icon.svg" loading="lazy" alt="Google Icon">
                            {{ 'auth.sign-in-with-google' | translate }}
                        </ng-template>
                    </button>
                    <button (click)="loginWithMicrosoft()" aria-label="Sign In with Microsoft">
                        <img src="../../../assets/img/microsoft-icon.png" loading="lazy" alt="Microsoft Icon">
                        {{'auth.sign-in-with-microsoft' | translate}}
                    </button>
                </div>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
                <div class="form-group">
                    <label for="email">{{'common.email' | translate}}</label>
                    <input type="email" id="email" class="form-control" formControlName='email'>
                    <div class="error-message" *ngIf="shouldShowError('email')">
                        {{ getErrorMessage('email') }}
                    </div>
                </div>

                <div class="form-group">
                    <label for="password">{{'common.password' | translate}}</label>
                    <div class="password-input-container">
                        <input [type]="getPasswordFieldType('password')" id="password" class="form-control"
                            formControlName='password' autocomplete>
                        <button type="button" class="toggle-password" (click)="togglePasswordVisibility('password')" aria-label="Toggle password visibility">
                            <img loading="lazy" [src]="showPasswords ? '../../../assets/svg/show-password-icon.svg' : '../../../assets/svg/hide-password-icon.svg'"
                                [alt]="showPasswords ? 'Hide password' : 'Show password'">
                        </button>
                        <div class="error-message" *ngIf="shouldShowError('password')">
                            {{ getErrorMessage('password') }}
                        </div>
                    </div>
                    <div class="forgot-password">
                        <a routerLink="/forgot-password">{{'auth.forgot-password.title' | translate}}</a>
                    </div>
                </div>

                <button type="submit" class="signin-btn" [disabled]="loginForm.invalid"
                    [ngClass]="{'disabled': loginForm.invalid}" aria-label="Login">
                    {{'buttons.login' | translate}}
                </button>

                <div class="signup-link">
                    {{'auth.no-account' | translate}} <a routerLink="/register">{{'buttons.register' | translate}}</a>
                </div>
            </form>
        </div>
    </div>
    <div class="login-img" [ngClass]="{'video-loaded': isVideoLoaded}">
        <div class="video-placeholder" *ngIf="!isVideoLoaded">
            <app-progress-spinner [color]="'primary'" [diameter]="50" [strokeWidth]="5" [mode]="'indeterminate'">
            </app-progress-spinner>
        </div>
        <video #loginVideo loop playsinline preload="auto" poster="../../../assets/img/safetly logo.png"
            (loadeddata)="onVideoLoaded()" (error)="onVideoError($event)" [style.opacity]="isVideoLoaded ? 1 : 0" loading="lazy">

            <source src="../../../assets/gifs/video-webm.webm" type="video/webm">
            <source src="../../../assets/gifs/video.mp4" type="video/mp4">

            <!-- fallback -->
            <img src="../../../assets/img/safetly logo.png" loading="lazy" alt="Safetly Logo" class="fallback-image">
        </video>

    </div>
</div>